import React from 'react';
import { Row, Col, Tabs } from 'antd'

import TabUUID from './uuid'
import TabText from './text'

const Index = () => {

    return (
        <Row style={{ textAlign: 'center', width: '100%' }}>
            <Col md={24} sm={24}>
                <h3 style={{ fontSize: 32, fontWeight: 'bold', display: 'block' }}>
                    Vibal QR Code Generator
                </h3>
            </Col>
            
            <Col md={24} sm={24}>
                <Tabs defaultActiveKey="uuid" style={{ padding: 20, height: '100%' }}>
                    <Tabs.TabPane tab="UUID" key="uuid">
                        <TabUUID />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Text" key="text">
                        <TabText />
                    </Tabs.TabPane>
                </Tabs>
            </Col>
        </Row>
    )
}

export default Index